import classNames from 'classnames';
import { Container } from 'yoso';
import { Page, PageProps } from '~/components/Page';
import './ErrorPage.scss';

export type ErrorPageProps = PageProps;
export const ErrorPage = ({ className, children, ...props }: ErrorPageProps) => (
  <Page className={classNames('error-page', className)} {...props}>
    <div className="error-page-body">
      <Container margin="auto">{children}</Container>
    </div>
  </Page>
);
